import { useEffect, useState } from "react";
import Toast from "./info/Toast";
import Tabs from "./tabs/Tabs";
import Spinner from "./Spinner";
import AlertMsg from "./info/AlertMsg";
import { BiHelpCircle } from "react-icons/bi";
import { useTour } from "@reactour/tour";
import { FaRoute } from "react-icons/fa";

const AppLayout = ({
  children,
  isLoading = false,
  loadingText = null,
  loadingDescription = null,
  title = "",
  subtitle = "",
  tab = 0,
  tabType = "",
  idForm = "",
  warningAlert = false,
  dangerAlert = false,
  showSubtitleInitialValue = false,
  tourSteps = [],
}) => {
  const [showSubtitle, setShowSubtitle] = useState(showSubtitleInitialValue);
  const { steps, setIsOpen, setCurrentStep, setSteps } = useTour();

  useEffect(() => {
    setSteps([...tourSteps]);
  }, []);
  return (
    <>
      <div className="home p-md-5 p-sm-3 pt-4 px-2">
        <div>
          <div className="d-flex align-items-center">
            <h1 className="m-0">
              <b>{title}</b>
            </h1>

            {subtitle && (
              <div
                className="buttonchat ps-2"
                onClick={() => setShowSubtitle(!showSubtitle)}
              >
                <p style={{ fontSize: "25px", color: "#2f3e9eff" }}>
                  <BiHelpCircle />
                </p>
              </div>
            )}
            {steps && steps.length != 0 && !isLoading && (
              <div
                id="tour-button"
                className="buttonchat ms-3 djaCenter"
                onClick={() => {
                  setIsOpen(true);
                  setCurrentStep(0);
                }}
              >
                <FaRoute size={"22px"} color="#2f3e9eff" />
              </div>
            )}
          </div>
          <p className={"subtitles" + (!showSubtitle ? " disabled" : "")}>
            {subtitle}
          </p>
          {dangerAlert && (
            <AlertMsg
              type="danger"
              text="Los cambios en esta sección pueden afectar el correcto
            funcionamiento del chatbot."
            />
          )}
          {warningAlert && (
            <AlertMsg
              text='Los cambios en esta sección requieren de un <strong>nuevo entrenamiento del
            chatbot para que surjan efecto</strong>.'
            />
          )}
        </div>
        {title && <hr />}
        <Toast key={title + tab} />
        {tabType && (
          <div className="row pb-3 gx-0">
            <Tabs type={tabType} tabSelected={tab} idForm={idForm} />
          </div>
        )}
        <div className="row my-0 gx-0">
          {isLoading ? <Spinner message={loadingText} description={loadingDescription} /> : children}
        </div>
      </div>
    </>
  );
};

export default AppLayout;
